import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import usePark from "common/hooks/usePark";
import { ObservationGrid } from "types/ObservationGrid";

const processOptions = (options: ObservationGrid[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function ObservationGridSelect(props: any) {
  const { park } = usePark();

  return (
    <RemoteSelect
      url="observation-grids"
      processOptions={processOptions}
      filters={[{ name: "park", value: park?.id }]}
      {...props}
    />
  );
}

export default ObservationGridSelect;
